import { GestioneCredenziali } from './GestioneCredenziali'
import { t } from '../i18n/lingua'

/**
 * La sezione «Connessioni» di un modulo (Backup, IPAM, DNS, Wazuh, Firewall):
 * le credenziali dei sistemi che quel modulo interroga in tempo reale, con lo
 * stesso form della pagina Credenziali. `funzioni` sono le funzioni del
 * catalogo che il modulo mostra (``backup``, ``ipam``, ``dns``…).
 */
export function Connessioni({
  funzioni,
  segnaposto,
  onChanged,
}: {
  funzioni: string[]
  segnaposto?: string
  onChanged?: () => void
}) {
  return (
    <>
      <p className="muted">
        {t('Sistemi interrogati in tempo reale dal modulo. Le credenziali di accesso sono cifrate e non sono più visualizzabili dopo il salvataggio.')}
      </p>
      <GestioneCredenziali
        filtro={(k) => Boolean(k.live) && funzioni.includes(k.feature)}
        titolo={t('Nuova connessione')}
        segnaposto={segnaposto}
        onChanged={onChanged}
      />
    </>
  )
}
